"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const responseError = require("./common/responseError");
const getCredentials_1 = require("./getCredentials");
const app_1 = require("./app");
function refreshAuthToken({ email, refreshToken }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            let _credentials;
            const body = {
                grant_type: 'refresh_token',
                refresh_token: refreshToken
            };
            const url = `https://securetoken.googleapis.com/v1/token?key=${app_1.app.options.apiKey}`;
            const result = yield fetch(url, {
                method: 'POST',
                body: JSON.stringify(body)
            });
            const data = yield result.json();
            _credentials = yield getCredentials_1.default();
            const { uid, domainId, role, providerId, googleAuthRefreshToken } = _credentials;
            const { access_token, refresh_token } = data;
            const credentials = {
                token: access_token,
                refreshToken: refresh_token,
                uid,
                role,
                email,
                domainId,
                providerId,
                googleAuthRefreshToken
            };
            addCredentials({ credentials, remember: true });
            return true;
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.refreshAuthToken = refreshAuthToken;
function addCredentials({ credentials, remember }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const credentialsKey = 'credentials';
            let _credentials;
            let timer;
            _credentials = credentials || null;
            if (credentials) {
                localStorage.setItem(credentialsKey, JSON.stringify(credentials));
                // clear the refresh timer
                if (timer) {
                    clearTimeout(timer);
                    timer = null;
                }
                // start the refresh timer for the credentials
                timer = setTimeout(() => {
                    const { refreshToken, email } = _credentials;
                    return refreshAuthToken({ refreshToken, email });
                }, 55 * 1000 * 60);
            }
            else {
                sessionStorage.removeItem(credentialsKey);
                localStorage.removeItem(credentialsKey);
            }
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = addCredentials;
//# sourceMappingURL=addCredentials.js.map